// extracted by mini-css-extract-plugin
export default {"statusIndicator":"TriageAgentButton-module__statusIndicator--GGURC","pulse":"TriageAgentButton-module__pulse--bROQW"};